import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const KEY = "sw_cookie_consent";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const choose = (value) => {
    try {
      localStorage.setItem(KEY, value);
    } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-[70] px-4 pb-4 sm:px-6 sm:pb-6"
    >
      <div className="mx-auto flex max-w-3xl flex-col gap-4 rounded-2xl border border-[#E2E8F0] bg-white/95 p-5 shadow-2xl shadow-slate-900/10 backdrop-blur-xl sm:flex-row sm:items-center sm:gap-6 sm:p-6">
        <div className="flex items-start gap-3.5">
          <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#EFF5FD] text-[#1E3A6E]">
            <Cookie size={17} strokeWidth={1.5} />
          </span>
          <p className="text-sm leading-relaxed text-[#334155]">
            We use essential cookies to keep this site working, and privacy-conscious analytics to improve it. See our{" "}
            <Link to="/legal/cookies" data-testid="cookie-policy-link" className="font-semibold text-[#1E3A6E] hover:underline">
              Cookie Policy
            </Link>
            .
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-2.5 sm:ml-auto">
          <button
            data-testid="cookie-decline"
            onClick={() => choose("declined")}
            className="flex-1 rounded-full border border-[#E2E8F0] bg-white px-5 py-2.5 text-sm font-semibold text-[#334155] transition-colors hover:bg-slate-50 sm:flex-none"
          >
            Decline
          </button>
          <button
            data-testid="cookie-accept"
            onClick={() => choose("accepted")}
            className="flex-1 rounded-full bg-[#1E3A6E] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#16294e] sm:flex-none"
          >
            Accept
          </button>
          <button
            data-testid="cookie-dismiss"
            onClick={() => choose("dismissed")}
            aria-label="Dismiss cookie notice"
            className="hidden h-9 w-9 items-center justify-center rounded-lg text-[#94A3B8] transition-colors hover:text-[#334155] sm:flex"
          >
            <X size={16} strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
